import moment from "moment/moment";

// export function calculateTimeDifference(date1, date2) {
//    // Define the acceptable date formats
//    const formats = ["YYYY-MM-DD", "YYYY-MM-DD HH:mm:ss"];

//    try {
//       // Check if both dates exist
//       if (!date1 || !date2) {
//          return undefined;
//       }

//       // Strictly validate the date formats using Moment.js
//       const isValidDate1 = moment(date1, formats, true).isValid();
//       const isValidDate2 = moment(date2, formats, true).isValid();

//       // Check if both dates are in the correct format
//       if (!isValidDate1 || !isValidDate2) {
//          return undefined;
//       }

//       // Parse the dates using Moment.js
//       const momentDate1 = moment(date1, formats, true);
//       const momentDate2 = moment(date2, formats, true);

//       // Calculate the difference in hours
//       const differenceInHours = momentDate2.diff(momentDate1, "hours");

//       return differenceInHours;
//    } catch (error) {
//       // Return undefined in case of any unexpected errors
//       return undefined;
//    }
// }

export function calculateTimeDifference(date1, date2) {
   const formats = ["YYYY-MM-DD", "YYYY-MM-DD HH:mm:ss"];

   try {
      // Check for null, undefined, or empty string values
      if (
         date1 === null ||
         date1 === undefined ||
         date1 === "" ||
         date2 === null ||
         date2 === undefined ||
         date2 === ""
      ) {
         return undefined;
      }

      // Validate and parse the dates strictly
      const momentDate1 = moment(date1, formats, true);
      const momentDate2 = moment(date2, formats, true);

      if (!momentDate1.isValid() || !momentDate2.isValid()) {
         return undefined;
      }

      // Calculate absolute difference in hours
      const differenceInHours = momentDate2.diff(momentDate1, "hours");

      return isNaN(differenceInHours) ? undefined : differenceInHours;
   } catch (error) {
      return undefined;
   }
}

export function calculateFormattedTimeDifference(date1, date2) {
   const formats = ["YYYY-MM-DD", "YYYY-MM-DD HH:mm:ss"];

   try {
      // Check for null, undefined, or empty string values
      if (
         date1 === null ||
         date1 === undefined ||
         date1 === "" ||
         date2 === null ||
         date2 === undefined ||
         date2 === ""
      ) {
         return undefined;
      }

      // Validate and parse the dates strictly
      const momentDate1 = moment(date1, formats, true);
      const momentDate2 = moment(date2, formats, true);

      if (!momentDate1.isValid() || !momentDate2.isValid()) {
         return undefined;
      }

      // Calculate absolute difference in milliseconds
      const duration = moment.duration(momentDate2.diff(momentDate1));

      const hours = Math.floor(Math.abs(duration.asHours()));
      const minutes = Math.abs(duration.minutes());

      // Format HH:MM with zero-padding
      const formatted = `${String(hours).padStart(2, "0")}:${String(minutes).padStart(
         2,
         "0"
      )}`;

      return formatted;
   } catch (error) {
      return undefined;
   }
}

export function calculateDayDifference(startDate, endDate) {
   try {
      const start = moment(startDate);
      const end = moment(endDate);

      return end.diff(start, "days"); // Returns the number of days between the dates
   } catch (error) {
      return 0;
   }
}

/**
 * Calculates payable working days for a driver between report start and end dates,
 * adjusted for driver's joining and exit dates.
 *
 * @param {string} reportStartDate - Format: YYYY-MM-DD
 * @param {string} reportEndDate - Format: YYYY-MM-DD
 * @param {string|null} doj - Driver's date of joining
 * @param {string|null} doe - Driver's date of exit
 * @returns {number} Number of payable days (0 if invalid or no overlap)
 */
export function calculatePayableDays(reportStartDate, reportEndDate, doj, doe) {
   try {
      const format = "YYYY-MM-DD";

      // Validate all dates
      const start = moment(reportStartDate, format, true);
      const end = moment(reportEndDate, format, true);
      const joining = doj ? moment(doj, format, true) : null;
      const exit = doe ? moment(doe, format, true) : null;

      if (!start.isValid() || !end.isValid()) {
         console.error("Invalid report date(s)", { reportStartDate, reportEndDate });
         return 0;
      }

      // Ensure start is before or equal to end
      if (end.isBefore(start)) {
         console.warn("Report end date is before start date");
         return 0;
      }

      const effectiveStart = joining && joining.isAfter(start) ? joining : start;
      const effectiveEnd = exit && exit.isBefore(end) ? exit : end;

      // If no overlap
      if (effectiveEnd.isBefore(effectiveStart)) {
         return 0;
      }

      const diff = effectiveEnd.diff(effectiveStart, "days") + 1; // inclusive
      return diff > 0 ? diff : 0;
   } catch (error) {
      console.error("Error calculating payable days:", error);
      return 0;
   }
}

export const convertHoursToDays = (hours, roundUp = false) => {
   try {
      // Normalize input
      const numericHours = Number(hours);

      // Check for invalid inputs
      if (
         isNaN(numericHours) || // Not a number
         numericHours < 0 || // Negative value
         typeof roundUp !== "boolean" // roundUp must be boolean
      ) {
         console.warn("Invalid input for convertHoursToDays:", { hours, roundUp });
         return 0;
      }

      const days = numericHours / 24;

      return roundUp ? Math.ceil(days) : parseFloat(days.toFixed(2));
   } catch (error) {
      console.error("Error in convertHoursToDays:", error);
      return 0;
   }
};
